import { Button, Typography } from '@material-ui/core'

const AboutPage = () => {
  return (
    <div>
      {' '}
      <div>
        <div
          style={{
            display: 'flex',
            padding: '5%',
            justifyContent: 'space-between',
            flexDirection: 'row',
            backgroundColor: 'white',
          }}
          className="Top_Area_Responsive"
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '4vh',
            }}
            className="Top_Area_Text_Left_Responsive"
          >
            <div
              style={{
                marginTop: '5vh',
                fontSize: '50px',
                width: '35vw',
                cursor: 'pointer',
              }}
            >
              <span
                className="underLine"
                style={{
                  fontFamily: " 'Ubuntu', sans-serif",
                  fontWeight: 'bolder',
                }}
              >
                Hi 👋
              </span>{' '}
              <br />{' '}
              <span
                className="underLine1 Responsive_Head"
                style={{
                  fontFamily: "'Roboto Mono', monospace",
                  fontWeight: '100',
                }}
              >
                We are team 13(virtual)
              </span>
            </div>
          </div>
          <div className="Top_Area_Text_Right_Responsive">
            <img src="/about_page.jpg" alt="helping image" />
          </div>
        </div>
        <div style={{}}>
          <Typography
            style={{
              width: '70vw',
              fontSize: '30px',
              margin: 'auto',
              textAlign: 'center',
              fontWeight: 'lighter',
            }}
            variant="subtitle1"
            color="initial"
          >
            Our team consists of <strong>Anita</strong>, <strong>Jacob</strong>,{' '}
            <strong>Joey</strong>, <strong>Saniya</strong> and{' '}
            <strong>Sourabh</strong>. We have worked on this hackathon being on
            five different timezones.
            <br />
            <br />
            Our app contains the Humanity 101 principles of compassion, empathy,
            and kindness. Our app will help Alzheimer’s sufferers to hold on to
            their memories and themselves,and give them hope and strength
            knowing that Alzheimer’s doesn't define their life anymore and they
            are not alone in their battle.
            <br />
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default AboutPage
